import React, { useState } from 'react';
import { uploadFile, downloadFile } from '../../../api/fileSystemService';

const FilesystemComponent = () => {
  const [folderPath, setFolderPath] = useState('');
  const [file, setFile] = useState(null);
  const [fileToDownload, setFileToDownload] = useState('');

  // upload file
  const handleUploadFile = async () => {
    if (!file) {
      alert('Please select a file first!');
      return;
    }
    
    try {
      const response = await uploadFile(folderPath, file);
      console.log('File uploaded:', response.relativePath);
      alert('File uploaded successfully!');
    } catch (error) {
      console.error('Error uploading file:', error);
      alert('Error uploading file.');
    }
  };

  // download file
  const handleDownloadFile = async () => {
    if (!fileToDownload) {
      alert('Please enter the file path to download!');
      return;
    }
    
    try {
      const response = await downloadFile(fileToDownload);
      const blob = new Blob([response], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileToDownload.split('/').pop(); // get file name
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading file:', error);
      alert('Error downloading file.');
    }
  };

  return (
    <div>
      <h2>Filesystem Operations</h2>

      {/* Upload File */}
      <input
        type="text"
        placeholder="Enter folder path"
        value={folderPath}
        onChange={(e) => setFolderPath(e.target.value)}
      />
      <input
        type="file"
        onChange={(e) => setFile(e.target.files[0])}
      />
      <button onClick={handleUploadFile}>Upload File</button>

      {/* Download File */}
      <input
        type="text"
        placeholder="Enter file path to download"
        value={fileToDownload}
        onChange={(e) => setFileToDownload(e.target.value)}
      />
      <button onClick={handleDownloadFile}>Download File</button>
    </div>
  );
};

export default FilesystemComponent;
